document.addEventListener("DOMContentLoaded", function () {
  // Inicialização melhorada para modo anônimo
  if (typeof window.ta === 'undefined') {
    console.log('window.ta não definido, inicializando estrutura básica...');
    window.ta = {
      settings: getFromStorage('settings', {}),
      products: getFromStorage('products', {}),
      lastSettingsUpdate: getFromStorage('lastSettingsUpdate', 0),
      lastProductUpdate: 0,
      cart: {
        showMixedCartAlert: true
      }
    };
  }

  function checkVariant (event, firstLoad) {
    let closestParent

    if (firstLoad) {
      closestParent = event.closest('.variant-input-label');
      closestParent.querySelector('input').checked = true;
      closestParent.querySelector('input').dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      closestParent = event.target.closest('.variant-input-label');
    }

    let label;
    if (closestParent) label = closestParent.querySelector('label[data-variant-id]');
    else label = event.target.closest('label[data-variant-id]');

    const container = document.querySelector('.product-form');
    const form = container?.querySelector('form');
    const form2 = document.getElementById('product-form-installment');
    const inputPreOrder = form?.querySelector('input[name="properties[Pre-order item]"]');
    const inputPreOrder2 = form2?.querySelector('input[name="properties[Pre-order item]"]');
    const buttonSubmitText = form?.querySelector('button[type="submit"] span');
    const buttonSubmit = form?.querySelector('button[type="submit"]');
    const preOrderContainer = form?.querySelector('.product-add-to-cart-container');
    const nameColorSelected = document.querySelector('.product-form__input--color .form__label__value')?.textContent.trim() || '';
    const nameSizeSelected = document.querySelector('.product-form__input--block .form__label__value')?.textContent.trim() || '';


    let variantId = null;
    let productId = null;
    let productHandle = null;
    let preOrder = null;
    let variantQuantity = null;

    if (!label) {
      const normalizedColor = nameColorSelected.toLowerCase().replace(/\s+/g, '_');
      label = event.target.closest('label[data-' + normalizedColor + '-variant-id]');
      if (!label) {
        return;
      }
      variantId = label.dataset[normalizedColor + 'VariantId'];
      productId = label.dataset.productId;
      productHandle = label.dataset.productHandle;
      preOrder = label.dataset[normalizedColor + 'PreOrder'];
      variantQuantity = label.dataset.variantQuantity;
    } else {
      variantId = label.dataset.variantId;
      productId = label.dataset.productId;
      productHandle = label.dataset.productHandle;
      preOrder = label.dataset.preOrder;
      variantQuantity = label.dataset.variantQuantity;

      const fieldsetDisabled = document.querySelector('.product-form__input--block');
      if (fieldsetDisabled) {
        const radios = fieldsetDisabled.querySelectorAll('input[type="radio"]');
        radios.forEach(radio => {
          radio.checked = false;
        });
        const firstRadio = fieldsetDisabled.querySelector('input[type="radio"]');
        if (firstRadio) {
          firstRadio.checked = true;
        }
      }
    }
    if (buttonSubmit) {
      buttonSubmit.disabled = true;
    }
    if (preOrderContainer) {
      removeMessagePreOrder(preOrderContainer);
    }
    if (form) {
      if (inputPreOrder) {
        form.removeChild(inputPreOrder);
      }
      if (inputPreOrder2) {
        form2.removeChild(inputPreOrder2);
      }
    }
    if (preOrder !== "true") {
      changeButtonText(buttonSubmitText, "ADD TO CART");
      buttonSubmit.disabled = false;
      return;
    } else if (preOrder === "true") {
      (async function () {
        let labelMessage;
        try {
          labelMessage = await window.initPreOrder({
            productId: productId,
            variantId: variantId,
            productHandle: productHandle
          });

          // Garante que sempre tem um valor válido
          if (!labelMessage || labelMessage === null) {
            labelMessage = "";
          }

          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[Pre-order item]';
          input.value = labelMessage;
          form.appendChild(input);

        } catch (error) {
          console.error('Erro ao carregar PreOrder:', error);
          // Fallback para garantir que o botão funcione
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[Pre-order item]';
          input.value = labelMessage;
          form.appendChild(input);
        } finally {
          changeButtonText(buttonSubmitText, "ADD TO CART");
          removeMessagePreOrder(preOrderContainer);
          buttonSubmit.disabled = false;
          addMessagePreOrder(preOrderContainer, labelMessage);
        }
      })();

    } else {
      buttonSubmit.disabled = false;
    }
  }

  document.addEventListener('click', function (event) {
    checkVariant(event, false);
  });

  // Função para garantir que as configurações estejam carregadas
  async function ensureSettingsLoaded() {
    // Se já tem configurações, retorna imediatamente
    if (window.ta?.settings && Object.keys(window.ta.settings).length > 0) {
      return true;
    }

    // Tenta carregar do localStorage primeiro
    const storedSettings = getFromStorage('settings', {});
    if (storedSettings && Object.keys(storedSettings).length > 0) {
      if (window.ta) {
        window.ta.settings = storedSettings;
      }
      return true;
    }

    // Se não tem no localStorage, busca da API
    const api = new Api();
    try {
      const settingsResponse = await api.getSettings();
      if (settingsResponse && settingsResponse.settings) {
        const settings = settingsResponse.settings;
        saveToStorage('settings', settings);
        if (window.ta) {
          window.ta.settings = settings;
        }
        return true;
      }
    } catch (error) {
      console.error('Erro ao buscar configurações da API:', error);
    }

    return false;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const paramsVariantId = urlParams.get('variant');

  const firstVariant = document.querySelector('.variations fieldset');
  let firstVariantLabel = null;
  let hasStock = true;
 
  if (paramsVariantId) {
    firstVariantLabel = firstVariant?.querySelector(`label[data-variant-id="${paramsVariantId}"]`);
    const variantSpan = document.querySelector(`.variations span[data-variant-id="${paramsVariantId}"]`);
    hasStock = variantSpan?.getAttribute('data-variant-quantity') > 0;

    if(!hasStock) {
      const allLabels = document.querySelectorAll('.variations .span-variant-informations');

      for (let label of allLabels) {
        if (label.getAttribute('data-variant-quantity') > 0) {
          const variantId = label.dataset.variantId;
          firstVariantLabel = firstVariant?.querySelector(`label[data-variant-id="${variantId}"]`);
          break;
        }
      }
    }
  } else {
    firstVariantLabel = firstVariant?.querySelector('label[data-variant-id]');
  }
  
  if (firstVariantLabel) {
    // Garante que as configurações estejam carregadas antes de processar a variante
    (async function() {
      await ensureSettingsLoaded();
      // Adiciona um pequeno delay adicional para garantir que tudo está pronto
      setTimeout(() => {
        checkVariant(firstVariantLabel, true);
      }, 100);
    })();
  }
});

function changeButtonText(button, text) {
  if (button) {
    button.textContent = text;
  } else {
    console.error("Button not found.");
  }
}

function addMessagePreOrder(container, message) {

  if (!container) {
    console.error("Container not found for Pre-order message.");
    return;
  }
  const messageElement = document.createElement('div');
  messageElement.className = 'timesact-preorder-description';
  messageElement.style.fontSize = '13px';
  messageElement.style.color = 'rgb(78, 78, 78)';
  messageElement.style.textAlign = 'center';
  messageElement.style.fontWeight = '400';
  messageElement.style.fontStyle = 'normal';
  messageElement.style.marginBottom = '10px';
  messageElement.style.marginTop = '10px';
  messageElement.style.display = 'block';
  messageElement.style.width = '100%';
  messageElement.style.padding = '0 10px';
  messageElement.style.textTransform = 'uppercase';
  messageElement.textContent = message;
  container.appendChild(messageElement);
}

function removeMessagePreOrder(container) {
  if (!container) {
    console.error("Container not found for Pre-order message.");
    return;
  }
  const messageElement = container.querySelector('.timesact-preorder-description');

  if (messageElement) {
    container.removeChild(messageElement);
  }
}

// Função para verificar se localStorage está disponível
function isLocalStorageAvailable() {
  try {
    const test = '__localStorage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

// Função para obter dados do localStorage com fallback
function getFromStorage(key, defaultValue = null) {
  if (!isLocalStorageAvailable()) {
    return defaultValue;
  }
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (e) {
    console.warn(`Erro ao acessar localStorage para a chave "${key}":`, e);
    return defaultValue;
  }
}

// Função para salvar dados no localStorage com fallback
function saveToStorage(key, value) {
  if (!isLocalStorageAvailable()) {
    console.warn('localStorage não está disponível, dados não serão persistidos');
    return false;
  }
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    console.warn(`Erro ao salvar no localStorage para a chave "${key}":`, e);
    return false;
  }
}

class Product {
  constructor(id, variants, title, sellingPlanGroups) {
    this.id = id;
    this.variants = variants;
    this.title = title;
    this.sellingPlans = sellingPlanGroups
      ? sellingPlanGroups
        .filter((group) => group.app_id === 'timesact')
        .reduce((acc, group) => acc.concat(group.selling_plans), [])
      : [];
    this.variantId = null;
    this.timesactVariants = {};
  }

  setActiveVariant(variantId) {
    this.variantId = variantId;
  }

  setTimesactVariants(productConfig) {
    if (!productConfig || !productConfig.variants) {
      console.error('[ERROR 2002]: Product config is undefined.');
      return;
    }
    this.timesactVariants = productConfig.variants;
  }

  hasCustomSettings() {
    return this.timesactVariants[this.variantId] && this.timesactVariants[this.variantId].settings;
  }

  getVariantSettings(settings, defaultSettingId, type) {
    // Configurações padrão de fallback
    const fallbackSettings = {
      button: { name: "PRE-ORDER" },
      message: { type: "info", value: "This product is available for pre-order" },
      cart: { labelText: { key: "Pre-order item", value: "Pre-order" } },
      badge: {}
    };

    // Se não há configurações válidas, retorna fallback
    if (!settings || Object.keys(settings).length === 0) {
      console.warn('Usando configurações padrão de fallback');
      return fallbackSettings;
    }

    const variant = this.timesactVariants[this.variantId];
    if (!variant?.config?.settingsTemplate) {
      const defaultSettings = settings[defaultSettingId] || fallbackSettings;
      if (!this.hasCustomSettings()) {
        return defaultSettings;
      }
      const customSettings = variant.settings;
      return {
        button: {
          ...defaultSettings.button,
          name: customSettings.buttonName || defaultSettings.button.name
        },
        message: {
          ...defaultSettings.message,
          type: customSettings.messageType || defaultSettings.message.type,
          value: customSettings.messageValue || defaultSettings.message.value,
        },
        cart: {
          ...defaultSettings.cart,
          labelText: {
            key: customSettings.cartLabelTextKey || defaultSettings.cart.labelText.key,
            value: customSettings.cartLabelTextValue || defaultSettings.cart.labelText.value,
          }
        },
        badge: defaultSettings.badge || {}
      };
    }

    const templates = {
      PO: variant.config?.settingsTemplate,
      BIS: variant.configBIS?.settingsTemplate,
      CS: variant.configCS?.settingsTemplate,
      IS: variant.configIS?.settingsTemplate,
    };

    const template = templates[type];
    const templateSettings = template && settings[template] ? settings[template] : settings[defaultSettingId];

    // Se não encontrar as configurações do template, usa fallback
    return templateSettings || fallbackSettings;
  }
}

class Api {
  static async getProductPreOrderConfig(productId) {
    try {
      return await $.ajax({
        url: `/apps/timesact/config?productId=${productId}`,
        type: 'GET',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        xhrFields: {
          withCredentials: true
        }
      });
    } catch (err) {
      console.error("Product is not active on pre-order.", err);
      return null;
    }
  }

  async getShop() {
    try {
      return await $.ajax({
        url: `/apps/timesact/shop`,
        type: 'GET',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        xhrFields: {
          withCredentials: true
        }
      });
    } catch (err) {
      console.error("Shop data couldn't be fetched.", err);
      return null;
    }
  }

  async getSettings() {
    try {
      return await $.ajax({
        url: `/apps/timesact/shop/settings`,
        type: 'GET',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        xhrFields: {
          withCredentials: true
        }
      });
    } catch (err) {
      console.error("Settings data couldn't be fetched.", err);
      return null;
    }
  }
}

async function initPreOrder({ productId, variantId, productHandle }) {
  const api = new Api();

  // Primeiro, tenta obter as configurações do window.ta
  let settings = window.ta?.settings || {};

  // Se não há configurações no window.ta, tenta carregar do localStorage
  if (!settings || Object.keys(settings).length === 0) {
    const storedSettings = getFromStorage('settings', {});
    if (storedSettings && Object.keys(storedSettings).length > 0) {
      settings = storedSettings;
      if (window.ta) {
        window.ta.settings = settings;
      }
    }
  }

  // Se ainda não há configurações, busca da API com retry
  if (!settings || Object.keys(settings).length === 0) {
    console.log('Configurações não encontradas no window.ta, buscando da API...');
    let retries = 3;
    let loaded = false;
    
    while (retries > 0 && !loaded) {
      try {
        const settingsResponse = await api.getSettings();
        if (settingsResponse && settingsResponse.settings) {
          settings = settingsResponse.settings;

          // Tenta salvar no localStorage se disponível
          saveToStorage('settings', settings);

          // Atualiza o window.ta se existir
          if (window.ta) {
            window.ta.settings = settings;
          }
          loaded = true;
        }
      } catch (error) {
        console.error(`Erro ao buscar configurações da API (tentativas restantes: ${retries - 1}):`, error);
        retries--;
        if (retries > 0) {
          // Aguarda um pouco antes de tentar novamente
          await new Promise(resolve => setTimeout(resolve, 300));
        }
      }
    }
  }

  const shop = await api.getShop();
  const defaultSettingIds = shop?.settings?.templates || {};

  const baseUrl = window.location.origin;
  let product = null;

  if (productHandle) {
    try {
      const data = await $.getJSON(`${baseUrl}/products/${productHandle}.js`);
      product = new Product(data.id, data.variants, data.title, data.selling_plan_groups);
      const timesactProduct = await Api.getProductPreOrderConfig(productId);

      if (!timesactProduct) {
        return;
      }

      product.setActiveVariant(variantId);
      product.setTimesactVariants(timesactProduct.product);

      // Verifica se há configurações válidas antes de prosseguir
      if (!settings || Object.keys(settings).length === 0) {
        console.warn('Configurações não disponíveis após tentativas, retornando undefined');
        return;
      }

      const variantSettings = product.getVariantSettings(settings, defaultSettingIds.PO, "PO");
      if (!variantSettings) {
        return;
      }

      return variantSettings.message?.value;

    } catch (err) {
      console.error("[Error 1001]: Product could not be fetched.", err);
      return;
    }
  }
  return;
}

window.initPreOrder = initPreOrder;